import { jsx as _jsx } from "react/jsx-runtime";
import { DpePartner } from '@as-react/common-types';
import DpeVitality from '../dpe-vitality/DpeVitality';
const DpeValidator = ({ digitalPartner, onValidationError, onValidationSuccess, }) => {
    const renderPartner = () => {
        switch (digitalPartner) {
            case DpePartner.VITALITY:
                return _jsx(DpeVitality, { onValidationSuccess: onValidationSuccess, onValidationError: onValidationError });
            default:
                return null;
        }
    };
    return renderPartner();
};
export default DpeValidator;
